import { GetterTree } from 'vuex';
import { LocationOpeningHoursState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<LocationOpeningHoursState, RootState> = {
  ['getOpeningHours']: state => state.openingHours,
}